
import Vue from 'vue';
export default Vue.extend({
  name: 'StackingNotification',
  props: {
    stackNotifications: {
      required: true,
      type: Array
    }
  },
  computed: {
    reversedNotifs(){
      return this.$props.stackNotifications.slice().reverse();
    }
  },
  methods: {
    close(message: string){
      this.$emit('eClose', message);
    },
    clearAll(){
      this.$emit('eClearAll');
    },
     reverse(array: any[]) {
      if(!array || array.length == 0) return []
      return array.slice(0,array.length - 1).reverse()
    }
  }
})
